/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppAdsUsersRouteImport } from './routes/_app.ads.users'
import { Route as AppAdsSpendDetailsRouteImport } from './routes/_app.ads.spend-details'
import { Route as AppAdsPermissionsRouteImport } from './routes/_app.ads.permissions'
import { Route as AppAdsPackagesRouteImport } from './routes/_app.ads.packages'
import { Route as AppAdsOperatorsRouteImport } from './routes/_app.ads.operators'
import { Route as AppAdsOperatorCodesRouteImport } from './routes/_app.ads.operator-codes'
import { Route as AppAdsMaterialProcessRouteImport } from './routes/_app.ads.material-process'
import { Route as AppAdsDashboardRouteImport } from './routes/_app.ads.dashboard'
import { Route as AppAdsAuditLogsRouteImport } from './routes/_app.ads.audit-logs'
import { Route as AppAdsAppsRouteImport } from './routes/_app.ads.apps'
import { Route as AppAdsAdProvidersRouteImport } from './routes/_app.ads.ad-providers'
import { Route as AppAdsAdPlatformsRouteImport } from './routes/_app.ads.ad-platforms'
import { Route as AppAdsAdAccountTransactionsRouteImport } from './routes/_app.ads.ad-account-transactions'
import { Route as AppAdsAccountsRouteImport } from './routes/_app.ads.accounts'
import { Route as AppAdsOperatorsIndexRouteImport } from './routes/_app.ads.operators.index'
import { Route as AppAdsMaterialProcessIndexRouteImport } from './routes/_app.ads.material-process.index'
import { Route as AppAdsAccountsIndexRouteImport } from './routes/_app.ads.accounts.index'
import { Route as AppAdsOperatorsIdRouteImport } from './routes/_app.ads.operators.$id'
import { Route as AppAdsMaterialsReviewRouteImport } from './routes/_app.ads.materials.review'
import { Route as AppAdsMaterialsDisplayRouteImport } from './routes/_app.ads.materials.display'
import { Route as AppAdsMaterialProcessNewRouteImport } from './routes/_app.ads.material-process.new'
import { Route as AppAdsAccountsIdRouteImport } from './routes/_app.ads.accounts.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdsUsersRoute = AppAdsUsersRouteImport.update({
  id: '/ads/users',
  path: '/ads/users',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsSpendDetailsRoute = AppAdsSpendDetailsRouteImport.update({
  id: '/ads/spend-details',
  path: '/ads/spend-details',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsPermissionsRoute = AppAdsPermissionsRouteImport.update({
  id: '/ads/permissions',
  path: '/ads/permissions',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsPackagesRoute = AppAdsPackagesRouteImport.update({
  id: '/ads/packages',
  path: '/ads/packages',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsOperatorsRoute = AppAdsOperatorsRouteImport.update({
  id: '/ads/operators',
  path: '/ads/operators',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsOperatorCodesRoute = AppAdsOperatorCodesRouteImport.update({
  id: '/ads/operator-codes',
  path: '/ads/operator-codes',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsMaterialProcessRoute = AppAdsMaterialProcessRouteImport.update({
  id: '/ads/material-process',
  path: '/ads/material-process',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsDashboardRoute = AppAdsDashboardRouteImport.update({
  id: '/ads/dashboard',
  path: '/ads/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsAuditLogsRoute = AppAdsAuditLogsRouteImport.update({
  id: '/ads/audit-logs',
  path: '/ads/audit-logs',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsAppsRoute = AppAdsAppsRouteImport.update({
  id: '/ads/apps',
  path: '/ads/apps',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsAdProvidersRoute = AppAdsAdProvidersRouteImport.update({
  id: '/ads/ad-providers',
  path: '/ads/ad-providers',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsAdPlatformsRoute = AppAdsAdPlatformsRouteImport.update({
  id: '/ads/ad-platforms',
  path: '/ads/ad-platforms',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsAdAccountTransactionsRoute =
  AppAdsAdAccountTransactionsRouteImport.update({
    id: '/ads/ad-account-transactions',
    path: '/ads/ad-account-transactions',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdsAccountsRoute = AppAdsAccountsRouteImport.update({
  id: '/ads/accounts',
  path: '/ads/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsOperatorsIndexRoute = AppAdsOperatorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdsOperatorsRoute,
} as any)
const AppAdsMaterialProcessIndexRoute =
  AppAdsMaterialProcessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdsMaterialProcessRoute,
  } as any)
const AppAdsAccountsIndexRoute = AppAdsAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdsAccountsRoute,
} as any)
const AppAdsOperatorsIdRoute = AppAdsOperatorsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdsOperatorsRoute,
} as any)
const AppAdsMaterialsReviewRoute = AppAdsMaterialsReviewRouteImport.update({
  id: '/ads/materials/review',
  path: '/ads/materials/review',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsMaterialsDisplayRoute = AppAdsMaterialsDisplayRouteImport.update({
  id: '/ads/materials/display',
  path: '/ads/materials/display',
  getParentRoute: () => AppRoute,
} as any)
const AppAdsMaterialProcessNewRoute =
  AppAdsMaterialProcessNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdsMaterialProcessRoute,
  } as any)
const AppAdsAccountsIdRoute = AppAdsAccountsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdsAccountsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/ads/accounts': typeof AppAdsAccountsRouteWithChildren
  '/ads/ad-account-transactions': typeof AppAdsAdAccountTransactionsRoute
  '/ads/ad-platforms': typeof AppAdsAdPlatformsRoute
  '/ads/ad-providers': typeof AppAdsAdProvidersRoute
  '/ads/apps': typeof AppAdsAppsRoute
  '/ads/audit-logs': typeof AppAdsAuditLogsRoute
  '/ads/dashboard': typeof AppAdsDashboardRoute
  '/ads/material-process': typeof AppAdsMaterialProcessRouteWithChildren
  '/ads/operator-codes': typeof AppAdsOperatorCodesRoute
  '/ads/operators': typeof AppAdsOperatorsRouteWithChildren
  '/ads/packages': typeof AppAdsPackagesRoute
  '/ads/permissions': typeof AppAdsPermissionsRoute
  '/ads/spend-details': typeof AppAdsSpendDetailsRoute
  '/ads/users': typeof AppAdsUsersRoute
  '/ads/accounts/$id': typeof AppAdsAccountsIdRoute
  '/ads/material-process/new': typeof AppAdsMaterialProcessNewRoute
  '/ads/materials/display': typeof AppAdsMaterialsDisplayRoute
  '/ads/materials/review': typeof AppAdsMaterialsReviewRoute
  '/ads/operators/$id': typeof AppAdsOperatorsIdRoute
  '/ads/accounts/': typeof AppAdsAccountsIndexRoute
  '/ads/material-process/': typeof AppAdsMaterialProcessIndexRoute
  '/ads/operators/': typeof AppAdsOperatorsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/ads/ad-account-transactions': typeof AppAdsAdAccountTransactionsRoute
  '/ads/ad-platforms': typeof AppAdsAdPlatformsRoute
  '/ads/ad-providers': typeof AppAdsAdProvidersRoute
  '/ads/apps': typeof AppAdsAppsRoute
  '/ads/audit-logs': typeof AppAdsAuditLogsRoute
  '/ads/dashboard': typeof AppAdsDashboardRoute
  '/ads/operator-codes': typeof AppAdsOperatorCodesRoute
  '/ads/packages': typeof AppAdsPackagesRoute
  '/ads/permissions': typeof AppAdsPermissionsRoute
  '/ads/spend-details': typeof AppAdsSpendDetailsRoute
  '/ads/users': typeof AppAdsUsersRoute
  '/ads/accounts/$id': typeof AppAdsAccountsIdRoute
  '/ads/material-process/new': typeof AppAdsMaterialProcessNewRoute
  '/ads/materials/display': typeof AppAdsMaterialsDisplayRoute
  '/ads/materials/review': typeof AppAdsMaterialsReviewRoute
  '/ads/operators/$id': typeof AppAdsOperatorsIdRoute
  '/ads/accounts': typeof AppAdsAccountsIndexRoute
  '/ads/material-process': typeof AppAdsMaterialProcessIndexRoute
  '/ads/operators': typeof AppAdsOperatorsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/ads/accounts': typeof AppAdsAccountsRouteWithChildren
  '/_app/ads/ad-account-transactions': typeof AppAdsAdAccountTransactionsRoute
  '/_app/ads/ad-platforms': typeof AppAdsAdPlatformsRoute
  '/_app/ads/ad-providers': typeof AppAdsAdProvidersRoute
  '/_app/ads/apps': typeof AppAdsAppsRoute
  '/_app/ads/audit-logs': typeof AppAdsAuditLogsRoute
  '/_app/ads/dashboard': typeof AppAdsDashboardRoute
  '/_app/ads/material-process': typeof AppAdsMaterialProcessRouteWithChildren
  '/_app/ads/operator-codes': typeof AppAdsOperatorCodesRoute
  '/_app/ads/operators': typeof AppAdsOperatorsRouteWithChildren
  '/_app/ads/packages': typeof AppAdsPackagesRoute
  '/_app/ads/permissions': typeof AppAdsPermissionsRoute
  '/_app/ads/spend-details': typeof AppAdsSpendDetailsRoute
  '/_app/ads/users': typeof AppAdsUsersRoute
  '/_app/ads/accounts/$id': typeof AppAdsAccountsIdRoute
  '/_app/ads/material-process/new': typeof AppAdsMaterialProcessNewRoute
  '/_app/ads/materials/display': typeof AppAdsMaterialsDisplayRoute
  '/_app/ads/materials/review': typeof AppAdsMaterialsReviewRoute
  '/_app/ads/operators/$id': typeof AppAdsOperatorsIdRoute
  '/_app/ads/accounts/': typeof AppAdsAccountsIndexRoute
  '/_app/ads/material-process/': typeof AppAdsMaterialProcessIndexRoute
  '/_app/ads/operators/': typeof AppAdsOperatorsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/ads/accounts'
    | '/ads/ad-account-transactions'
    | '/ads/ad-platforms'
    | '/ads/ad-providers'
    | '/ads/apps'
    | '/ads/audit-logs'
    | '/ads/dashboard'
    | '/ads/material-process'
    | '/ads/operator-codes'
    | '/ads/operators'
    | '/ads/packages'
    | '/ads/permissions'
    | '/ads/spend-details'
    | '/ads/users'
    | '/ads/accounts/$id'
    | '/ads/material-process/new'
    | '/ads/materials/display'
    | '/ads/materials/review'
    | '/ads/operators/$id'
    | '/ads/accounts/'
    | '/ads/material-process/'
    | '/ads/operators/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/ads/ad-account-transactions'
    | '/ads/ad-platforms'
    | '/ads/ad-providers'
    | '/ads/apps'
    | '/ads/audit-logs'
    | '/ads/dashboard'
    | '/ads/operator-codes'
    | '/ads/packages'
    | '/ads/permissions'
    | '/ads/spend-details'
    | '/ads/users'
    | '/ads/accounts/$id'
    | '/ads/material-process/new'
    | '/ads/materials/display'
    | '/ads/materials/review'
    | '/ads/operators/$id'
    | '/ads/accounts'
    | '/ads/material-process'
    | '/ads/operators'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/ads/accounts'
    | '/_app/ads/ad-account-transactions'
    | '/_app/ads/ad-platforms'
    | '/_app/ads/ad-providers'
    | '/_app/ads/apps'
    | '/_app/ads/audit-logs'
    | '/_app/ads/dashboard'
    | '/_app/ads/material-process'
    | '/_app/ads/operator-codes'
    | '/_app/ads/operators'
    | '/_app/ads/packages'
    | '/_app/ads/permissions'
    | '/_app/ads/spend-details'
    | '/_app/ads/users'
    | '/_app/ads/accounts/$id'
    | '/_app/ads/material-process/new'
    | '/_app/ads/materials/display'
    | '/_app/ads/materials/review'
    | '/_app/ads/operators/$id'
    | '/_app/ads/accounts/'
    | '/_app/ads/material-process/'
    | '/_app/ads/operators/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/ads/users': {
      id: '/_app/ads/users'
      path: '/ads/users'
      fullPath: '/ads/users'
      preLoaderRoute: typeof AppAdsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/spend-details': {
      id: '/_app/ads/spend-details'
      path: '/ads/spend-details'
      fullPath: '/ads/spend-details'
      preLoaderRoute: typeof AppAdsSpendDetailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/permissions': {
      id: '/_app/ads/permissions'
      path: '/ads/permissions'
      fullPath: '/ads/permissions'
      preLoaderRoute: typeof AppAdsPermissionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/packages': {
      id: '/_app/ads/packages'
      path: '/ads/packages'
      fullPath: '/ads/packages'
      preLoaderRoute: typeof AppAdsPackagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/operators': {
      id: '/_app/ads/operators'
      path: '/ads/operators'
      fullPath: '/ads/operators'
      preLoaderRoute: typeof AppAdsOperatorsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/operator-codes': {
      id: '/_app/ads/operator-codes'
      path: '/ads/operator-codes'
      fullPath: '/ads/operator-codes'
      preLoaderRoute: typeof AppAdsOperatorCodesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/material-process': {
      id: '/_app/ads/material-process'
      path: '/ads/material-process'
      fullPath: '/ads/material-process'
      preLoaderRoute: typeof AppAdsMaterialProcessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/dashboard': {
      id: '/_app/ads/dashboard'
      path: '/ads/dashboard'
      fullPath: '/ads/dashboard'
      preLoaderRoute: typeof AppAdsDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/audit-logs': {
      id: '/_app/ads/audit-logs'
      path: '/ads/audit-logs'
      fullPath: '/ads/audit-logs'
      preLoaderRoute: typeof AppAdsAuditLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/apps': {
      id: '/_app/ads/apps'
      path: '/ads/apps'
      fullPath: '/ads/apps'
      preLoaderRoute: typeof AppAdsAppsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/ad-providers': {
      id: '/_app/ads/ad-providers'
      path: '/ads/ad-providers'
      fullPath: '/ads/ad-providers'
      preLoaderRoute: typeof AppAdsAdProvidersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/ad-platforms': {
      id: '/_app/ads/ad-platforms'
      path: '/ads/ad-platforms'
      fullPath: '/ads/ad-platforms'
      preLoaderRoute: typeof AppAdsAdPlatformsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/ad-account-transactions': {
      id: '/_app/ads/ad-account-transactions'
      path: '/ads/ad-account-transactions'
      fullPath: '/ads/ad-account-transactions'
      preLoaderRoute: typeof AppAdsAdAccountTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/accounts': {
      id: '/_app/ads/accounts'
      path: '/ads/accounts'
      fullPath: '/ads/accounts'
      preLoaderRoute: typeof AppAdsAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/operators/': {
      id: '/_app/ads/operators/'
      path: '/'
      fullPath: '/ads/operators/'
      preLoaderRoute: typeof AppAdsOperatorsIndexRouteImport
      parentRoute: typeof AppAdsOperatorsRoute
    }
    '/_app/ads/material-process/': {
      id: '/_app/ads/material-process/'
      path: '/'
      fullPath: '/ads/material-process/'
      preLoaderRoute: typeof AppAdsMaterialProcessIndexRouteImport
      parentRoute: typeof AppAdsMaterialProcessRoute
    }
    '/_app/ads/accounts/': {
      id: '/_app/ads/accounts/'
      path: '/'
      fullPath: '/ads/accounts/'
      preLoaderRoute: typeof AppAdsAccountsIndexRouteImport
      parentRoute: typeof AppAdsAccountsRoute
    }
    '/_app/ads/operators/$id': {
      id: '/_app/ads/operators/$id'
      path: '/$id'
      fullPath: '/ads/operators/$id'
      preLoaderRoute: typeof AppAdsOperatorsIdRouteImport
      parentRoute: typeof AppAdsOperatorsRoute
    }
    '/_app/ads/materials/review': {
      id: '/_app/ads/materials/review'
      path: '/ads/materials/review'
      fullPath: '/ads/materials/review'
      preLoaderRoute: typeof AppAdsMaterialsReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/materials/display': {
      id: '/_app/ads/materials/display'
      path: '/ads/materials/display'
      fullPath: '/ads/materials/display'
      preLoaderRoute: typeof AppAdsMaterialsDisplayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ads/material-process/new': {
      id: '/_app/ads/material-process/new'
      path: '/new'
      fullPath: '/ads/material-process/new'
      preLoaderRoute: typeof AppAdsMaterialProcessNewRouteImport
      parentRoute: typeof AppAdsMaterialProcessRoute
    }
    '/_app/ads/accounts/$id': {
      id: '/_app/ads/accounts/$id'
      path: '/$id'
      fullPath: '/ads/accounts/$id'
      preLoaderRoute: typeof AppAdsAccountsIdRouteImport
      parentRoute: typeof AppAdsAccountsRoute
    }
  }
}

interface AppAdsAccountsRouteChildren {
  AppAdsAccountsIdRoute: typeof AppAdsAccountsIdRoute
  AppAdsAccountsIndexRoute: typeof AppAdsAccountsIndexRoute
}

const AppAdsAccountsRouteChildren: AppAdsAccountsRouteChildren = {
  AppAdsAccountsIdRoute: AppAdsAccountsIdRoute,
  AppAdsAccountsIndexRoute: AppAdsAccountsIndexRoute,
}

const AppAdsAccountsRouteWithChildren = AppAdsAccountsRoute._addFileChildren(
  AppAdsAccountsRouteChildren,
)

interface AppAdsMaterialProcessRouteChildren {
  AppAdsMaterialProcessNewRoute: typeof AppAdsMaterialProcessNewRoute
  AppAdsMaterialProcessIndexRoute: typeof AppAdsMaterialProcessIndexRoute
}

const AppAdsMaterialProcessRouteChildren: AppAdsMaterialProcessRouteChildren = {
  AppAdsMaterialProcessNewRoute: AppAdsMaterialProcessNewRoute,
  AppAdsMaterialProcessIndexRoute: AppAdsMaterialProcessIndexRoute,
}

const AppAdsMaterialProcessRouteWithChildren =
  AppAdsMaterialProcessRoute._addFileChildren(
    AppAdsMaterialProcessRouteChildren,
  )

interface AppAdsOperatorsRouteChildren {
  AppAdsOperatorsIdRoute: typeof AppAdsOperatorsIdRoute
  AppAdsOperatorsIndexRoute: typeof AppAdsOperatorsIndexRoute
}

const AppAdsOperatorsRouteChildren: AppAdsOperatorsRouteChildren = {
  AppAdsOperatorsIdRoute: AppAdsOperatorsIdRoute,
  AppAdsOperatorsIndexRoute: AppAdsOperatorsIndexRoute,
}

const AppAdsOperatorsRouteWithChildren = AppAdsOperatorsRoute._addFileChildren(
  AppAdsOperatorsRouteChildren,
)

interface AppRouteChildren {
  AppAdsAccountsRoute: typeof AppAdsAccountsRouteWithChildren
  AppAdsAdAccountTransactionsRoute: typeof AppAdsAdAccountTransactionsRoute
  AppAdsAdPlatformsRoute: typeof AppAdsAdPlatformsRoute
  AppAdsAdProvidersRoute: typeof AppAdsAdProvidersRoute
  AppAdsAppsRoute: typeof AppAdsAppsRoute
  AppAdsAuditLogsRoute: typeof AppAdsAuditLogsRoute
  AppAdsDashboardRoute: typeof AppAdsDashboardRoute
  AppAdsMaterialProcessRoute: typeof AppAdsMaterialProcessRouteWithChildren
  AppAdsOperatorCodesRoute: typeof AppAdsOperatorCodesRoute
  AppAdsOperatorsRoute: typeof AppAdsOperatorsRouteWithChildren
  AppAdsPackagesRoute: typeof AppAdsPackagesRoute
  AppAdsPermissionsRoute: typeof AppAdsPermissionsRoute
  AppAdsSpendDetailsRoute: typeof AppAdsSpendDetailsRoute
  AppAdsUsersRoute: typeof AppAdsUsersRoute
  AppAdsMaterialsDisplayRoute: typeof AppAdsMaterialsDisplayRoute
  AppAdsMaterialsReviewRoute: typeof AppAdsMaterialsReviewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdsAccountsRoute: AppAdsAccountsRouteWithChildren,
  AppAdsAdAccountTransactionsRoute: AppAdsAdAccountTransactionsRoute,
  AppAdsAdPlatformsRoute: AppAdsAdPlatformsRoute,
  AppAdsAdProvidersRoute: AppAdsAdProvidersRoute,
  AppAdsAppsRoute: AppAdsAppsRoute,
  AppAdsAuditLogsRoute: AppAdsAuditLogsRoute,
  AppAdsDashboardRoute: AppAdsDashboardRoute,
  AppAdsMaterialProcessRoute: AppAdsMaterialProcessRouteWithChildren,
  AppAdsOperatorCodesRoute: AppAdsOperatorCodesRoute,
  AppAdsOperatorsRoute: AppAdsOperatorsRouteWithChildren,
  AppAdsPackagesRoute: AppAdsPackagesRoute,
  AppAdsPermissionsRoute: AppAdsPermissionsRoute,
  AppAdsSpendDetailsRoute: AppAdsSpendDetailsRoute,
  AppAdsUsersRoute: AppAdsUsersRoute,
  AppAdsMaterialsDisplayRoute: AppAdsMaterialsDisplayRoute,
  AppAdsMaterialsReviewRoute: AppAdsMaterialsReviewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
